
const copyContent = async (copyTimeoutRef, setCopying, message) => {
  if (!message) return;
  const sanitizedMessage = message.replace(/\*/g, '');
  try {
    await navigator.clipboard.writeText(sanitizedMessage);
    setCopying(true);

    if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
    copyTimeoutRef.current = setTimeout(() => {
      setCopying(false); 
      copyTimeoutRef.current = null;
    }, 650);
  } catch (err) {
    console.error('Failed to copy:', err);
    setCopying(false);
  }
};

export { copyContent }